import { LinearProgress, linearProgressClasses } from "@mui/material";
import React, { useEffect, useState } from "react";
import { strings } from "../../Store/Localization";

export default function PasswordStrength(props: any) {
  const [password, setPassword] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [strength, setStrength] = useState("");
  useEffect(() => {
    validatePassword(props.password);
  }, [props.password]);
  const validatePassword = (input: any) => {
    const lengthScore = input.length >= 12 ? 2 : input.length >= 8 ? 1 : 0;
    const hasUpperCase = /[A-Z]/.test(input);
    const hasLowerCase = /[a-z]/.test(input);
    const hasDigit = /[0-9]/.test(input);
    const hasSpecialChar =
      /[!@#\$%\^&\*\(\)_\+\-\=\[\]\{\};:\'",<>\.\?\/\\\|`~]/.test(input);
    // Calculate score based on presence of different character types
    let typeScore = 0;
    if (hasUpperCase) typeScore++;
    if (hasLowerCase) typeScore++;
    if (hasDigit) typeScore++;
    if (hasSpecialChar) typeScore++;
    // Total score based on length and type variety
    const totalScore = lengthScore + typeScore;
    // Determine password strength
    if (totalScore <= 1) {
      return "Too Weak";
    } else if (totalScore === 2) {
      return "Weak";
    } else if (totalScore === 3) {
      return "Moderate";
    } else if (totalScore === 4) {
      return "Strong";
    } else {
      return "Very Strong";
    }
  };
  const validatePasswordT = (input: any) => {
    const lengthScore = input.length >= 12 ? 2 : input.length >= 8 ? 1 : 0;
    const hasUpperCase = /[A-Z]/.test(input);
    const hasLowerCase = /[a-z]/.test(input);
    const hasDigit = /[0-9]/.test(input);
    const hasSpecialChar =
      /[!@#\$%\^&\*\(\)_\+\-\=\[\]\{\};:\'",<>\.\?\/\\\|`~]/.test(input);
    // Calculate score based on presence of different character types
    let typeScore = 0;
    if (hasUpperCase) typeScore++;
    if (hasLowerCase) typeScore++;
    if (hasDigit) typeScore++;
    if (hasSpecialChar) typeScore++;
    // Total score based on length and type variety
    const totalScore = lengthScore + typeScore;
    if (totalScore <= 1) {
      return strings.weak;
    } else if (totalScore === 2) {
      return strings.weak;
    } else if (totalScore === 3) {
      return strings.moderate;
    } else if (totalScore === 4) {
      return strings.strong;
    } else {
      return strings.strong;
    }
  };
  return (
    <div
      style={{
        alignItems: "center",

        display: "flex",
        flexDirection: "row",
        marginBottom:20,
        marginTop:10

      }}
    >
      <div style={{ height: "10px", borderRadius: 16, width: "88%",marginLeft:"2%" }}>
        <LinearProgress
          value={
            validatePassword(props.password) === "Very Strong"
              ? 100
              : validatePassword(props.password) === "Strong"
              ? 75
              : validatePassword(props.password) === "Moderate"
              ? 50
              : validatePassword(props.password) === "Weak"
              ? 25
              : 0
          }
          variant="determinate"
          // color={
            // validatePassword(props.password) === 'Too Weak'
            //   ? 'red'
            //   : validatePassword(props.password) === 'Weak'
            //   ? 'orange'
            //   : validatePassword(props.password) === 'Moderate'
            //   ? '#ffe200'
            //   : validatePassword(props.password) === 'Strong'
            //   ? 'green'
            //   : 'limegreen'
          // }
          // visible={true}
          // style={{
          //   width: SCREEN_WIDTH - 40,
          //   borderRadius: 100,
          // }}1
          style={{ borderRadius: 16, height: 10, backgroundColor: "#00000010" }}
          sx={{
            [`& .${linearProgressClasses.bar}`]: {
              borderRadius: 5,
              backgroundColor:  validatePassword(props.password) === 'Too Weak'
              ? 'red'
              : validatePassword(props.password) === 'Weak'
              ? 'orange'
              : validatePassword(props.password) === 'Moderate'
              ? '#ffe200'
              : validatePassword(props.password) === 'Strong'
              ? '#16A34A'
              : 'limegreen'
            },
          }}
        />
      </div>
      <div style={{ width: "10%",display:'flex',alignItems:'flex-end',justifyContent:'flex-end' }}>
        <p style={{ ...styles.strengthText, margin: 0,fontFamily:'montserrat-SemiBold',fontSize:14,
            color:validatePassword(props.password) === 'Too Weak'
            ? 'red'
            : validatePassword(props.password) === 'Weak'
            ? 'orange'
            : validatePassword(props.password) === 'Moderate'
            ? '#ffe200'
            : validatePassword(props.password) === 'Strong'
            ? '#16A34A'
            : 'limegreen'
         }}>
          {validatePasswordT(props.password)}
        </p>
      </div>
    </div>
  );
}
const styles = {
  container: {
    flex: 1,
    alignItems: "flex-end",
    display: "flex",
    flexDirection: "row",
  },
  Heading: {
    marginTop: 40,
    padding: 40,
  },
  HeadingText: {
    fontSize: 25,
    alignItems: "center",
    fontWeight: "bold",
  },
  textInput: {
    borderWidth: 1,
    width: 300,
    padding: 10,
    marginBottom: 10,
  },
  strengthText: {
    fontSize: 12,
    color: "#007700",
  },
  suggestionsText: {
    color: "red",
  },
  strengthMeter: {
    width: "80%",
    height: 20,
    backgroundColor: "#ccc",
    marginTop: 20,
    borderRadius: 10,
    overflow: "hidden",
  },
};
